import React from "react";
import { CheckCircle } from "lucide-react";
import Saloncycle from "./saloncycle";
import Footer from "../../Home/Footer";
import WhatsAppServices from "../../Home/WhatsAppServices";
import Faqs from "../../Home/Faqs";
// Array for dynamic data
const travelLeadData = {
  heading: "Boost Spa & Salon Bookings with WhatsApp Solutions",
  points: [
    "Send irresistible offers and discounts to thousands of customers instantly.",
    "Stay connected 24/7 with smart WhatsApp automation.",
    "Highlight your services beautifully with a WhatsApp storefront.",
  ],
  buttons: [
    { text: "Try ChatMitra for Growth", className: "bg-[#075E54] text-white hover:bg-[#064d40]",buttonLink:"https://app.chatmitra.com/signin" },
    { text: "Schedule a Live Demo", className: "border border-[#075E54] text-[#075E54] hover:text-white" },
  ],
  image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/spa_salon/spa_salon_1.png",
};


const spaSalonServices = [
  {
    id: 1,
    icon: <span className="text-2xl">💆</span>, // Massage icon
    title: "Increase Bookings with WhatsApp",
    description: "Let clients schedule massages, haircuts, or facials via WhatsApp. It’s like having a personal assistant making life easier for them!"
  },
  {
    id: 2,
    icon: <span className="text-2xl">✂️</span>, // Scissors icon
    title: "Promote Services on WhatsApp",
    description: "Highlight new treatments, packages, and specials through WhatsApp. Your clients will be eager to book their next pampering session."
  },
  {
    id: 3,
    icon: <span className="text-2xl">💬</span>, // Chat bubble icon
    title: "Offer Consultations via WhatsApp",
    description: "Answer skincare questions, recommend treatments, and build trust with instant WhatsApp chats. Clients will feel confident choosing you."
  },
  {
    id: 4,
    icon: <span className="text-2xl">📅</span>, // Calendar icon
    title: "Manage Appointments on WhatsApp",
    description: "Coordinate rescheduling, cancellations, and reminders through WhatsApp. It’s a smooth way to keep your schedule full and clients happy."
  },
  {
    id: 5,
    icon: <span className="text-2xl">💆‍♀️</span>, // Female spa icon
    title: "Send Wellness Tips via WhatsApp",
    description: "Share skincare routines, relaxation tips, and post-treatment care through WhatsApp. It’s a great way to build loyalty and repeat visits."
  },
  {
    id: 6,
    icon: <span className="text-2xl">⭐</span>, // Star icon
    title: "Gather Feedback on WhatsApp",
    description: "Ask for reviews on services, ambiance, or staff via WhatsApp. It’s quick, easy, and helps you shine brighter to new clients."
  }
];



const spaSalonFAQs = [
  {
    question: "How can WhatsApp increase my spa bookings?",
    answer: "WhatsApp can skyrocket your bookings by letting clients schedule massages, facials, or haircuts directly through chats. It’s like having a personal assistant making life easier for them!"
  },
  {
    question: "Is WhatsApp secure for spa appointments?",
    answer: "Yes, WhatsApp’s encryption keeps your booking details and client data safe. It’s like locking your spa schedule in a vault, so clients can relax knowing their info is protected."
  },
  {
    question: "Can customers book services on WhatsApp?",
    answer: "Absolutely! They can reserve treatments, check availability, and confirm via WhatsApp. It’s like having a front desk that’s always open, no matter the hour."
  },
  {
    question: "How does WhatsApp promote spa services?",
    answer: "Send special offers, new treatment alerts, and wellness tips via WhatsApp. It’s like whispering luxury invites to your clients, turning interest into appointments."
  },
  {
    question: "What beauty content should I share on WhatsApp?",
    answer: "Share skincare routines, treatment before-afters, and loyalty rewards via WhatsApp. It’s a direct line to keep clients coming back for more pampering."
  },
  {
    question: "Can WhatsApp handle spa customer inquiries?",
    answer: "Yes! Answer questions about services, products, or pricing via WhatsApp in real time. It’s like having a concierge who’s always ready to assist with a smile."
  },
  {
    question: "How do spa clients feel about using WhatsApp?",
    answer: "They love it! Clients appreciate the speed, convenience, and personal touch of WhatsApp. It’s less formal than calls and more immediate, making bookings a delight."
  },
  {
    question: "Can WhatsApp reduce my salon’s scheduling stress?",
    answer: "Definitely! Automate reminders, rescheduling, and confirmations via WhatsApp, freeing your team for hands-on work. It’s like having a scheduler who never misses a beat."
  },
  {
    question: "How can I collect feedback on WhatsApp for my spa?",
    answer: "Send surveys or ask for reviews on services and ambiance via WhatsApp. It’s a quick way to improve and show clients you value their experience."
  },
  {
    question: "How do I set up WhatsApp for my spa or salon?",
    answer: "Set up WhatsApp Business, create chat templates for bookings and promotions, and use tools like ChatMitra. It’s a simple step to boost your beauty bookings!"
  },
];


const Salonpage = () => {
  return (
    <>
      <section className="max-w-6xl mx-auto px-4 py-16 bg-white pt-28">
        <div className="flex flex-col lg:flex-row gap-12">
          <div className="w-full lg:w-1/2">
            <h1 className="text-4xl font-bold text-gray-800 mb-6">Boost Spa & Salon Bookings with WhatsApp Solutions</h1>
            <ul className="space-y-4 text-gray-700">
              {travelLeadData.points.map((point, index) => (
                <li key={index} className="flex items-start gap-3">
                  <CheckCircle className="text-[#075E54] w-5 h-5 flex-shrink-0" />
                  <span>{point}</span>
                </li>
              ))}
            </ul>
            <div className="mt-8 flex gap-4">
              {travelLeadData.buttons.map((button, index) => (
                <a
                key={index}
                href={button.buttonLink}
                className={`py-3 px-6 rounded-lg text-lg font-semibold ${button.className}`}
              >
                {button.text}
              </a>
              ))}
            </div>
          </div>
          <div className="w-full lg:w-1/2">
            <img src={travelLeadData.image} alt="Spa & Salon Leads" className="w-full h-auto rounded-lg  hover:scale-105 transition-transform" />
          </div>
        </div>

        <div className="max-w-6xl mx-auto px-4 py-8 text-center">
          <p className="text-lg text-gray-600">Grow your spa and salon business effortlessly with WhatsApp. Start today with ChatMitra—no credit card needed!</p>
          <button className="mt-4 bg-[#075E54] text-white py-3 px-6 rounded-lg hover:bg-[#064d40] transition-colors">Get Start - No Credit Card Required</button>
        </div>
      </section>

      <Saloncycle />
      <WhatsAppServices servicesData={spaSalonServices} isVisible={true}/>
      <Faqs faqs={spaSalonFAQs} />
      <title>Grow Your Spa & Salon with WhatsApp | ChatMitra</title>
      <meta name="description" content="Increase spa and salon bookings with WhatsApp. Automate reminders, promote services, and engage customers seamlessly with ChatMitra." />
      <meta name="keywords" content="WhatsApp for spas, salon bookings, spa marketing, WhatsApp automation, customer engagement, salon services promotion" />
      <meta property="og:title" content="Grow Your Spa & Salon with WhatsApp | ChatMitra" />
      <meta property="og:description" content="Use WhatsApp to boost spa and salon appointments, send offers, and keep customers engaged with automated solutions." />
      <meta property="og:url" content="https://blog.chatmitra.com/whatsapp-business-for-spas-and-salons" />
      <meta property="og:type" content="website" />
      <Footer />
    </>
  );
};

export default Salonpage;
